import loadable from '@loadable/component';

const Blocks = {
    highlighted_text_block: loadable(() => import('./HighlightedTextBlock')),
    call_to_action_block: loadable(() => import('./CallToActionBlock')),
    rich_text_block: loadable(() => import('./RichTextBlock')),
    image_text_block: loadable(() => import('./ImageTextBlock')),
    stock_status_block: loadable(() => import('./StockStatusBlock')),
    cookietractor_information_block: loadable(() => import('./CookietractorInformationBlock')),
    configurator_block: loadable(() => import('./ConfiguratorBlock')),
};

export default Blocks;
